import React from "react";
import "./Footer.css";
import logo from "../../assets/images/ZE (1).png";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import gameData from "../../JSON/gameData.json";

function Footer() {
  const games = gameData?.slice(0, 10);
  return (
    <div className="footer">
      <div className="main-container h-100">
        <div className="row m-0 h-100 d-flex py-3">
          <div className="col-12 col-md-2">
            <img
              src={logo}
              alt=""
              width={"100%"}
              style={{ maxWidth: "200px" }}
            />
          </div>

          <div className="col-10 d-flex flex-wrap gap-5 footerLinks">
            <div className="d-flex flex-column">
              <h6 style={{ fontWeight: "700" }}>Resources</h6>
              <div className="menuLinks ">
                <a href="/aboutus">About Us</a>
                <a href="/contactus">Contact Us</a>
                <a href="/privacy-policy">Privacy</a>
                <a href="/developer">Developer</a>
                <a href="/terms-and-conditions">Term & Condition</a>
                <a href="/dmca">DMCA</a>
              </div>
            </div>
            <div className="d-flex flex-column">
              <h6
                style={{ fontWeight: "700" }}
                className="d-block text-start w-100">
                Games
              </h6>
              <div className="menuLinks  d-flex gap-4">
                <div>
                  {gameData?.slice(0, 5).map((game, index) => {
                    return (
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        key={index}
                        href={`/game/${game.shortUrl}`}
                        className="text-nowrap">
                        {game.title}
                      </a>
                    );
                  })}
                </div>
                <div>
                  {gameData?.slice(5, 10).map((game, index) => {
                    return (
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        key={index}
                        href={`/game/${game.shortUrl}`}
                        className="text-nowrap">
                        {game.title}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
            {/* <div className="d-flex flex-column">
              <h6 style={{ fontWeight: "700" }}>Connect</h6>
              <div className="d-flex ">
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="#"
                  style={{ color: "black" }}>
                  <FaFacebookSquare size={20} />
                </a>
                <a href="#" target="_blank" style={{ color: "black" }}>
                  <FaInstagram className="ms-2" size={20} />
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
